import { render, staticRenderFns } from "./scientistdtail.vue?vue&type=template&id=639318e5&scoped=true"
import script from "./scientistdtail.vue?vue&type=script&lang=js"
export * from "./scientistdtail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639318e5",
  null
  
)

export default component.exports